import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CatalogoService } from 'src/app/aplicaciones-modulos/distribuidores/services/catalogo.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { IndicadoresVivosVModel } from '../../models/indicadoresVivosVModel';
import { CarteraCargasUploadCsvService } from '../../services/cartera-cargas-upload-csv.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cartera-cargas-upload-csv',
  templateUrl: './cartera-cargas-upload-csv.component.html',
  styleUrls: ['./cartera-cargas-upload-csv.component.css']
})

export class CarteraCargasUploadCsvComponent implements OnInit {

  titulo = 'Carga de Carteras';
  mostrarFormulario = false;

  textoBuscar = '';
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  columnDefsCarteras: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];
  rowDataCarteras: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading: boolean = false;
  listaVacia: boolean = true;

  modulo: any = {};


  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  modelGrid: any;
  csv: string;
  objSelected: any = {};
  listaVaciaCli: boolean = true;
  errorData: boolean = true;
  cmbOpciones: { clave: number; valor: string; }[];

  cmbOpcionesV2: any[] = [
    { clave: true, valor: 'SI' },
    { clave: false, valor: 'NO' }
  ]

  cmbTipoDePresupuesto: any[] = [
    { clave: 1, valor: 'LE-COMERCIAL' },
    { clave: 2, valor: 'LE-COMISIONES' }
  ]

  listTipoCarga: any[] = [
    { clave: 0, valor: 'EFECTIVIDAD_VENCIMIENTO_DE_CARTERA' },
    { clave: 1, valor: 'RECAUDOS' }
  ]

  constructor(
    public fb: FormBuilder,
    private _util: UtilsService,
    private catalogo: CatalogoService,
    private _serviciosCRUD: CarteraCargasUploadCsvService,
    private router: Router,
  ) { }

  ngOnInit() {

    this.formulario = this.fb.group({
      anio: ['', [Validators.required]],
      tipoCarga: ['', [Validators.required]],
      multipart: ['', [Validators.required]],
    });

    const innClase = new IndicadoresVivosVModel();
    this.modelGrid = innClase.devolverGridCarteras();

    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    this.cargarIconosFiltros();
    this.cargarGrid();
    this.cargarGridCarteras();
    this.getTodo();

    this.formulario.get('multipart').valueChanges
      .subscribe((resp) => {
        this.getFormValidationErrors();
      });

  }

  /** FUNCIONES */
  getTodo() {
    this.listaVacia = true;
    this.loading = true;

    this._serviciosCRUD.getTodo().subscribe((res: any[]) => {
      console.log("getTodo()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowDataCarteras = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowDataCarteras = [];
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
      else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return true;
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'ESTADO',
        sortable: true,
        filter: true,
        width: 180,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) {
          return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO';
        }
      },
      {
        headerName: 'Año',
        field: this.modelGrid.anio,
        filter: true,
        width: 120,
        sortable: true
      },
      {
        headerName: 'Mes Inicio',
        field: this.modelGrid.mesInicioDescripcion,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Mes Fin',
        field: this.modelGrid.mesFinDescripcion,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'Tipo Carga',
        field: this.modelGrid.tipoCarga,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'Código Vendedor',
        field: this.modelGrid.idVendedor,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'Nombre Vendedor',
        field: this.modelGrid.nombreVendedor,
        filter: true,
        width: 400,
        sortable: true
      },
      {
        headerName: 'Valor Inicial',
        field: this.modelGrid.valorInicial,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'Valor Final',
        field: this.modelGrid.valorFinal,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'Cumplimiento',
        field: this.modelGrid.cumplimiento,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'ERROR',
        field: 'error.errorCampo',
        cellStyle: this.changeRowColor.bind(this),
        filter: true,
        width: 600,
        sortable: true
      },
    ];
    this.rowSelection = 'multiple';
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
    // this.router.navigate(['/comisiones/cartera-cargas-csv']);
  }

  regresarHome() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
    this.router.navigate(['/comisiones/cartera-cargas-csv']);
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.correct) {
        this.errorData = false;
      }
    });
  }

  enviarFormulario() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._serviciosCRUD.procesarCsv(this.setFormData(this.formulario.value), this.formulario.get('anio').value, this.formulario.get('tipoCarga').value),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  guardar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente listado?',
        text: '',
        action: 'Guardar',
        funcion: this._serviciosCRUD.saveCsv(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getTodo();
      this.regresar();
      this._util.mensajeOKVisto(res, true, 10000);
      // this.downloadDataCsv();
      // setTimeout(() => {
      // }, 1000);
    }).catch((err) => {
      console.log('Error ' + err);
      // this.getTodo();
      // this.regresar();
      this._util.mensajeErrorVisto(err.error.message, true, 3000);

    });
  }

  downloadCsvFormato() {
    let cabecera: any[] = [['MES INICIO', 'MES FIN', 'VENDEDOR', 'INICIAL', 'FINAL', 'CUMPLIMIENTO']];
    const data: any[] = [
      { 'mesInicio': '1', 'mesFin': 2, 'vendedor': '3113', 'cliente': '70', 'articulo': '90', 'cajas': 100 }
    ];
    let name: string = "formato-plantilla.csv";
    this._util.exportCSV(cabecera, data, name);
  }

  downloadDataCsv() {
    let data: any = [];
    let cabecera: any[] = [['Estado', 'Año', 'Mes Inicio', 'Mes Fin', 'Tipo Carga', 'ID Vendedor	', 'Nombre Vendedor', 'Valor Inicial', 'Valor Final', 'Cumplimiento', 'Línea', 'Error']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
      if (!e.correct) {
        data.push(
          {
            estado: (e.correct) ? 'CORRECTO' : 'INCORRECTO',
            anio: (e.anio === undefined) ? '' : e.anio,
            mesInicioDescripcion	: (e.mesInicioDescripcion	 === undefined) ? '' : e.mesInicioDescripcion	,
            mesFinDescripcion	: (e.mesFinDescripcion	 === undefined) ? '' : e.mesFinDescripcion	,
            tipoCarga	: (e.tipoCarga	 === undefined) ? '' : e.tipoCarga	,
            idVendedor	: (e.idVendedor	 === undefined) ? '' : e.idVendedor	,
            nombreVendedor: (e.nombreVendedor === undefined) ? '' : e.nombreVendedor,
            valorInicial: (e.valorInicial === undefined) ? '' : e.valorInicial,
            valorFinal: (e.valorFinal === undefined) ? '' : e.valorFinal,
            cumplimiento: (e.cumplimiento === undefined) ? '' : e.cumplimiento,
            linea: (e.error === undefined) ? '' : e.error.linea,
            errorCampo: (e.error === undefined) ? '' : e.error.errorCampo,
          }
        );
      }
    });
    let name: string = "REGISTRO_ERRORES.csv";
    this._util.exportCSV(cabecera, data, name);
    // this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

  setCodigoArticulo({ codigoArticulo, contenedor }) {
    if (codigoArticulo !== undefined && contenedor !== undefined && contenedor !== "") {
      return `${codigoArticulo}/${contenedor}`
    } else {
      if (codigoArticulo !== undefined) {
        return `${codigoArticulo}`;
      } else {
        return '';
      }
    }
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }


  cargarGridCarteras() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefsCarteras = [
      {
        headerName: 'Id',
        field: 'idCartera',
        filter: true,
        sortable: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Año',
        field: 'anio',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Mes Inicio',
        field: 'mesInicioDescripcion',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Mes Fin',
        field: 'mesFinDescripcion',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Tipo Carga',
        field: 'tipoCarga',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Vendedor',
        field: 'vendedorId',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },{
        headerName: 'Valor Inicial',
        field: 'valorInicial',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },{
        headerName: 'Valor Final',
        field: 'valorFinal',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },{
        headerName: 'Cumplimiento',
        field: 'cumplimiento',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 150,
      //   cellRendererParams: {
      //     onClick: this.editar.bind(this),
      //     label: this.DAT_BTNS.editar,
      //     colorBoton: this.DAT_BTNCSS.warning
      //   }
      // },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 150,
      //   cellRendererParams: {
      //     onClick: this.eliminar.bind(this),
      //     label: this.DAT_BTNS.eliminar,
      //     colorBoton: this.DAT_BTNCSS.danger
      //   }
      // },
    ];

    this.rowSelection = 'multiple';
  }

}
